// jshint asi: true
// jshint devel: true
// jshint unused:false

function clickTransition() {
	$('a[href*="http"]').click(function(e) {
		if (e.metaKey !== true && !$(e.target).hasClass('carreras_slider_dot_JS')) {
			if ( $(this).attr('target') !== '_blank' && !this.hasAttribute('download')) {
				if ( $(this).parents('.hero_txt_JS').length === 0  ) {
					$('#pre').fadeIn('fast')
				}
			}
		}
	})
}

$(window).on('ready', function() {
	$('#pre').fadeOut('slow')
})